import { CategoriesAPI } from "../api/CategoriesAPI";
import {AppStore} from "../desktop";
import {BaseService} from "./BaseService";
import { Document } from "../models/Document";
import {
	actionDeleteTabForItemId,
	actionSetTabItem,
	actionSetTabState,
	actionSetTabStateItem
} from "../store/tabs/actions";
import {ErrorService} from "./ErrorService";
import {DocumentsAPI} from "../api/DocumentsAPI";
import {
	actionDocumentFetch,
	actionDocumentFetchAllCompleted,
	actionDocumentFetchCompleted,
	actionDocumentForIndexingFetchAllCompleted,
	actionDocumentIndexingNumberCompleted,
	actionDocumentIndexingNumberRequest,
	DocumentsActionTypes
} from "../store/documents";
import {actionToastrInfo} from "../store/global";

export default class DocumentsService extends BaseService {

	// static getAll() {
	//
    //     let documentsAPI: DocumentsAPI = new DocumentsAPI()
	//
	// 	documentsAPI.getAll().then(DocumentsService.processResponse)
	// 	.then((result) => actionDocumentFetchAllCompleted(DocumentsService.fromAPIList(result)))
	// 	.catch(error => ErrorService.handleError(error))
	// }

	static getAllForIndexing() {

		let documentsAPI: DocumentsAPI = new DocumentsAPI()

		documentsAPI.getAllForIndexing().then(DocumentsService.processResponse)
			.then((result) => actionDocumentForIndexingFetchAllCompleted(result))
			.catch(error => ErrorService.handleError(error))
	}

	static getAllIndexed() {

		let documentsAPI: DocumentsAPI = new DocumentsAPI()

		documentsAPI.getAllIndexed().then(DocumentsService.processResponse)
			.then((result) => actionDocumentFetchAllCompleted(result))
			.catch(error => ErrorService.handleError(error))
	}

    static getOne(document: Document) {

		let documentsAPI: DocumentsAPI = new DocumentsAPI()

		documentsAPI.get(document).then(DocumentsService.processResponse).then(result => {
			actionDocumentFetchCompleted(DocumentsService.fromAPIItem(result))
        }).catch(error => {
        	// todo move 12 to error constants
        	if (error.response && error.response.data && error.response.data.errorId === 12) {
				actionDocumentFetchCompleted(Document.generateNotAllowed())
			} else {
				ErrorService.handleError(error)
			}
		})

    }

    static save(document: Document) {

		let documentsAPI: DocumentsAPI = new DocumentsAPI()

		if (document.id) {
			documentsAPI.put(DocumentsService.itemToRequest(document)).then(DocumentsService.processResponse).then(
				(data) => {
					let newDocument = DocumentsService.fromAPIItem(data)
					AppStore.dispatch({
						type: DocumentsActionTypes.SAVE_COMPLETED, payload: newDocument
					})
					actionToastrInfo("Info", "Dokument je uspešno snimljen")
					actionDocumentFetch(newDocument)
					actionSetTabItem(newDocument)
					// actionSetTabStateItem(DocumentsService.fromAPIToStateItem(data))
					// actionSetTabItem(DocumentsService.fromAPIItem(data))
				}
			).catch(error => ErrorService.handleError(error))
		} else {
			documentsAPI.post(DocumentsService.itemToRequest(document)).then(DocumentsService.processResponse).then(
				(data) => {
					let newDocument = DocumentsService.fromAPIItem(data)
					AppStore.dispatch({
						type: DocumentsActionTypes.SAVE_COMPLETED, payload: newDocument
					})
					actionToastrInfo("Info", "Dokument je uspešno snimljen")
					actionDocumentFetch(DocumentsService.fromAPIItem(data))
					actionDocumentIndexingNumberRequest()
					actionSetTabStateItem(newDocument)
					actionSetTabItem(newDocument)

					//actionSetTabStateItem(DocumentsService.fromAPIToStateItem(data))
					//actionSetTabItem(DocumentsService.fromAPIItem(data))
				}
			).catch(error => ErrorService.handleError(error))

		}

	}

	static delete(document: Document) {

		let documentsAPI: DocumentsAPI = new DocumentsAPI()

		documentsAPI.delete(DocumentsService.itemToRequest(document)).then(DocumentsService.processResponse).then(
			(data) => {
				AppStore.dispatch({
					type: DocumentsActionTypes.DELETE_COMPLETED, payload: document
				})
				actionToastrInfo("Info", "Dokument je uspešno obrisan")
				actionDeleteTabForItemId(document.id)
			}
		).catch(error => ErrorService.handleError(error))
	}

	static deleteMultiple(documents: Document[], unindexed: boolean) {

		let documentsAPI: DocumentsAPI = new DocumentsAPI()
		let count = 0;
		documents.forEach(document => {

			documentsAPI.delete(DocumentsService.itemToRequest(document)).then(DocumentsService.processResponse).then(
				(data) => {
					count++;
					actionDeleteTabForItemId(document.id)
					actionToastrInfo("Info", "Dokument je uspešno obrisan")
					if(count === documents.length)
						AppStore.dispatch({
							type: DocumentsActionTypes.DELETE_MULTIPLE_COMPLETED, payload: {documents, unindexed}
						})
				}
			).catch(error => ErrorService.handleError(error))
		});

	}

	static performAction(action: string, document: Document) {
		let documentsAPI: DocumentsAPI = new DocumentsAPI()
		documentsAPI.action(action, DocumentsService.itemToRequest(document)).then(DocumentsService.processResponse).then(
			(data) => {
				AppStore.dispatch({
					type: DocumentsActionTypes.PERFORM_ACTION_COMPLETED, payload: DocumentsService.fromAPIItem(data)
				})
				actionToastrInfo("Info", "Akcija je uspešno izvršena")
				actionDocumentFetch(document)
				// actionSetTabStateItem(DocumentsService.fromAPIToStateItem(data))
				// actionSetTabItem(DocumentsService.fromAPIItem(data))
			}
		).catch(error => ErrorService.handleError(error))
	}

	static getIndexingNumber() {
		let documentsAPI: DocumentsAPI = new DocumentsAPI()
		documentsAPI.indexingNumber().then(DocumentsService.processResponse).then(
			(data) => {
				actionDocumentIndexingNumberCompleted(data)
			}
		).catch(error => ErrorService.handleError(error))
	}

    static fromAPIList(apiList: any): Document[] {
        const localList = apiList.map((apiItem: any) => DocumentsService.fromAPIItem(apiItem));
        console.info('[fromAPICategoryList] converted categories: ', localList);
        return localList;
    }

    static fromAPIItem(apiItem: any): Document{
        let document = new Document();

		if (apiItem.id === "1de6972d-eea2-45f5-b77e-97109887b260") {
			console.log(document)
		}

		try {
			document.id = apiItem.id;
			document.parentId = apiItem.parentId
			// document.fields = JSON.parse(apiItem.fields)
			document.fields = apiItem.fields
			document.type = apiItem.type
			document.title = apiItem.title
			document.uploads = apiItem.uploads
			document.actions = apiItem.actions
			document.state = apiItem.state
			document.indexingDate = apiItem.indexingDate
			document.indexingNumber = apiItem.indexingNumber
			document.assignedTo = apiItem.assignedTo
			document.fields.assignedTo = apiItem.assignedTo

		} catch (error) {
			console.log(error)
		}

		if (typeof document.fields != "object") {
			document.fields = {}
		}

		try {
			document.tags = JSON.parse(apiItem.tags)
		} catch (error) {
			document.tags = []
		}

		try {
			document.visibleTo = JSON.parse(apiItem.visibleTo)
		} catch (error) {
			document.visibleTo = []
		}

        return document;
    }

	static fromAPIToStateItem(apiItem: any): any{
		let document = JSON.parse(apiItem.fields);
		return document;
	}

    static itemToRequest (document: Document): any {

		let itemRequest: any = {}

		if(document.id)
        	itemRequest.id = document.id

		itemRequest.parentId = document.parentId
		itemRequest.title = document.title
		itemRequest.fields = document.fields
		itemRequest.type = document.type
		itemRequest.assignedTo = document.assignedTo
		itemRequest.tags = JSON.stringify(document.tags)
		itemRequest.visibleTo = JSON.stringify(document.visibleTo)
		itemRequest.indexingNumber = document.indexingNumber
		itemRequest.indexingDate = document.indexingDate

		return itemRequest
	}

	static responseToItems (data: any) {
		return data
	}

}
